<div class="margin-right">
  <canvas #chart width="400" height="110"></canvas>
</div>
